import { map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';

import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { LoadJobsiteSalesArea } from '../../../actions/jobsite-actions/jobsite.actions';
import { Injectable } from '@angular/core';
import { getJobsiteState, OrderBuilderState } from '../../../../../reducers';
import { IJobsiteState } from '../../../reducers/jobsite-reducer/jobsite.reducer';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { LocationElements } from '../../../configs/location-element';

@Injectable()
export class JobsiteLoadSalesAreaCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(
    value: number,
    formGroup: UntypedFormGroup,
    form: ConfigurableFormComponent,
    config: FieldConfig,
  ): void {
    this.store
      .select(getJobsiteState)
      .pipe(
        take(1),
        map((state: IJobsiteState) => {
          return state.jobsites.find((jobsite: IShipmentLocation) => {
            return jobsite.shipmentLocationId === value;
          });
        }),
      )
      .subscribe((jobsite: IShipmentLocation) => {
        this.store.dispatch(new LoadJobsiteSalesArea(jobsite));
        const control = formGroup.get(LocationElements.PURCHASE_ORDER);
        control.updateValueAndValidity();
      });
  }
}
